import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './Pages/Home';
import { AboutUs } from './Pages/AboutUs';
import { Courses } from './Pages/Courses';
import { Contact } from './Pages/Contact';
import { Admission } from './Pages/Admission';
import { Admin } from './Pages/Admin';
import { Header } from './Components/Header';
import { Footer } from './Components/Footer';
import { GroupPricing} from './Pages/GroupPricing';
import { IndividualPricing } from './Pages/IndividualPricing';
import {AdminLogin} from './Pages/AdminLogin';
import t from './i18n/Translations';
import { Toaster} from 'sonner';
import { ProtectedRoute } from './Components/ProtectedRoute';
import { useState, useEffect } from 'react';
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./Firebase";

/**
 * 
 * A1 Tutorial Application
 * 
 * This website is a complete redesign of the existing A1 tutorial website.
 * This version is a modern learning platform for tutoring centres.
 * It clearly displays all and complete details of their services.
 * It also provides an easy way for students to get in touch with the tutoring centres.
 * The website is built using React for the frontend, Node.js with Express for the backend and 
 * Firebase for authentication and database management.
 * The application is designed to be responsive and user-friendly, ensuring a seamless experience across all devices.
 * 
 * The main features of the application include:
 * - A clean and intuitive user interface.
 * - Detailed information about tutoring services.
 * - Contact forms for easy communication between students and tutoring centres.
 * - Integration with a backend server for data management.
 * The goal of this project is to create a modern, efficient, 
 * and user-friendly platform that meets the needs of both students and tutoring centres.
 * 
 * 
 * @author Rubeth Rokonuzzaman, Thomas Dubois and Nathan Demosthene
 * @version 1.0
 * 
 */



function App() {
  // State to manage the current language selection (default is English)
  const [language, setLanguage] = useState("en");

  const currentTranslations = t[language];
  const [isConnected, setConnected] = useState(false);

  useEffect(() => {
    // Exemple d'une partie de ce code trouver sur : https://www.villageai.jp/2024/11/18/blog-20241118/
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setConnected(true);
      } else {
        setConnected(false);
      }
    });
    return () => unsubscribe();
  }, []);

  
  return (
    // Set up the Router for navigation between pages and define the routes
    <Router>
      <Toaster position="top-center" richColors /> 
      <div className="app-layout">
        <Header language={language} setLanguage={setLanguage}t={currentTranslations}isConnected={isConnected}setConnected={setConnected}/>
        <div className="content">
          <Routes>
          <Route path="/" element={<Home t={currentTranslations}/>} />
          <Route path="/aboutus" element={<AboutUs t={currentTranslations} />} />
          <Route path="/courses" element={<Courses t={currentTranslations} />} />
          <Route path="/contact" element={<Contact t={currentTranslations} />} />
          <Route path="/groupPricing" element={<GroupPricing t={currentTranslations} />} />
          <Route path="/individualPricing" element={<IndividualPricing t={currentTranslations} />} />
          <Route path="/admission" element={<Admission t={currentTranslations} />} />
          <Route 
          //exemple de code trouver sur : https://coreui.io/answers/how-to-protect-routes-in-react-router/
              path="/admin" 
              element={
                <ProtectedRoute>
                  <Admin t={currentTranslations} />
                </ProtectedRoute>
              } 
            />
          <Route path="/admin-login" element={<AdminLogin t={currentTranslations} setConnected={setConnected} />} />
        </Routes>
        </div>
        <Footer t={currentTranslations} />
      </div>
    </Router>
  );
}

export default App;
